import { render, staticRenderFns } from "./NextCard.vue?vue&type=template&id=087bdeb8&"
import script from "./NextCard.vue?vue&type=script&lang=js&"
export * from "./NextCard.vue?vue&type=script&lang=js&"
import style0 from "./NextCard.vue?vue&type=style&index=0&id=087bdeb8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports